export default "__VITE_ASSET__ac94fe39__"